import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export enum ModalTypesEnum {
  DELETE_CONFIRMATION = 'DELETE_CONFIRMATION',
  CONFIRM = 'CONFIRM',
  FILE_SYSTEM_ACTION = 'FILE_SYSTEM_ACTION',
  CREATE_WORKBENCH = 'CREATE_WORKBENCH',
  CREATE_EMR_STUDIO = 'CREATE_EMR_STUDIO',
  CREATE_EMR_CLUSTER = 'CREATE_EMR_CLUSTER',
  CREATE_PROJECT = 'CREATE_PROJECT',
  EDIT_PROJECT = 'EDIT_PROJECT',
  CONNECTION_INSTRUCTIONS = 'CONNECTION_INSTRUCTIONS',
  DATASET_CONNECTION_INSTRUCTIONS = 'DATASET_CONNECTION_INSTRUCTIONS',
  REQUEST_DATASET_ACCESS = 'REQUEST_DATASET_ACCESS',
  CREATE_DATASET = 'CREATE_DATASET',
  EDIT_DATASET = 'EDIT_DATASET',
  IMPORT_DATA_TO_DATASET = 'IMPORT_DATA_TO_DATASET',
  DEACTIVATE_PROJECT = 'DEACTIVATE_PROJECT',
  ETL_SCHEDULE_JOB = 'ETL_SCHEDULE_JOB',
  FAILED_ETL_JOB_DETAILS = 'FAILED_ETL_JOB_DETAILS',
  CHANGE_REGION = 'CHANGE_REGION',
  PUBLISH_TO_ATLAN = 'PUBLISH_TO_ATLAN',
  JOB_LOGS = 'JOB_LOGS',
  NOTICE_BANNER = 'NOTICE_BANNER',
}

type ModalType = {
  id: string;
  type: ModalTypesEnum;
  payload?: Record<string, unknown>;
};

const initialState: ModalType[] = [];

const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<Omit<ModalType, 'id'>>) => {
      const { type, payload } = action.payload;

      const filteredModals = state.filter((modal) => modal.type !== type);

      filteredModals.push({
        type,
        payload,
        id: crypto.randomUUID(),
      });

      return filteredModals;
    },
    closeModalById: (state, action: PayloadAction<string>) => {
      return state.filter((modal) => modal.id !== action.payload);
    },
  },
  selectors: {
    selectOpenModals: (state) => state,
  },
});

export const { selectOpenModals } = modalSlice.selectors;
export const { openModal, closeModalById } = modalSlice.actions;

export default modalSlice.reducer;
